import { Dispatch as ReactStateDispatch, SetStateAction } from 'react';
import { Dispatch } from 'redux';
import { refreshCurrentUserToken } from '@core/components/src/XAuth/redux/actions';

const checkCustom = (store: any, name: string) => store[name];

interface CreateAuthDs {
  dataSource: any;
  dataGridRef: any;
  jwt: string;
  dispatch: Dispatch<any>;
  setUnauthorized: ReactStateDispatch<SetStateAction<boolean>>;
}

export const createAuthDs = ({
  dataSource,
  dataGridRef,
  jwt,
  dispatch,
  setUnauthorized
}: CreateAuthDs) => {
  const customBeforeSend = checkCustom(dataSource.store, 'beforeSend');

  dataSource.store.beforeSend = (request: any) => {
    request.headers.Authorization = `Bearer ${jwt}`;

    if (customBeforeSend) {
      customBeforeSend(request);
    }
  };

  const customErrorHandler = checkCustom(dataSource.store, 'errorHandler');

  dataSource.store.errorHandler = (err: { httpStatus: number }) => {
    if (err.httpStatus === 401) {
      setUnauthorized(true);

      if (dataGridRef && dataGridRef.instance) {
        dataGridRef.instance.beginCustomLoading();
      }

      const refreshAction = refreshCurrentUserToken(() => {
        setUnauthorized(false);

        if (dataGridRef && dataGridRef.instance) {
          dataGridRef.instance.endCustomLoading();
        }
      });

      dispatch(refreshAction);
    }

    if (customErrorHandler) {
      customErrorHandler(err);
    }
  };

  return dataSource;
};
